import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PRODUCT_IMAGE, SCROLL_TARGET } from '../data/content';
function goToPurchase() {
  document.getElementById(SCROLL_TARGET)?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
}
export function HeroSection() {
  return <header className="relative overflow-hidden bg-cream" data-id="element-57">
      <div className="mx-auto max-w-3xl px-5 pb-20 pt-12 text-center sm:pt-16" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-59">
          <h1 className="font-serif text-4xl font-semibold leading-[1.05] text-ink sm:text-5xl lg:text-6xl" data-id="element-60">
            Educación Saludable
          </h1>

          <p className="mx-auto mt-5 max-w-2xl font-serif text-xl italic leading-relaxed text-sage-deep sm:text-2xl" data-id="element-61">
            Un recetario digital con recetas simples, nutritivas y fáciles de
            preparar, pensado para acompañar una alimentación saludable en
            personas con patologías como la tiroides.
          </p>
        </motion.div>

        <motion.button type="button" onClick={goToPurchase} aria-label="Ver la oferta de Mega Pack Tiroides" initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="group relative mx-auto mt-10 block w-full max-w-2xl" data-id="element-62">
          <img src={PRODUCT_IMAGE} alt="Mega Pack Tiroides — 9 tomos y tablet con la colección completa" className="w-full rounded-3xl shadow-2xl shadow-ink/15 transition-transform duration-500 group-hover:scale-[1.02]" data-id="element-63" />
          <span className="absolute -bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-coral px-5 py-2 text-sm font-bold text-white shadow-lg" data-id="element-64">
            9 tomos + 5 bonos
          </span>
        </motion.button>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        delay: 0.25
      }} className="mx-auto mt-12 flex max-w-2xl flex-col items-center" data-id="element-65">
          <div className="space-y-4 text-[17px] leading-relaxed text-ink/75" data-id="element-66">
            <p data-id="element-67">
              <strong className="font-bold text-coral-deep" data-id="element-68">
                ¿TENÉS HIPOTIROIDISMO Y ESTÁS SIEMPRE CANSADA, SUBIENDO DE PESO
                O CON NIEBLA MENTAL?
              </strong>{' '}
              Sentís que hacés todo bien, pero tu cuerpo no responde? Llegaste
              al lugar correcto.
            </p>
            <p data-id="element-69">
              Acá está todo eso. Resuelto. Para tu cocina, con ingredientes de
              todos los días.
            </p>
          </div>

          <div className="mt-7" data-id="element-70">
            <CTAButton variant="coral" size="lg" data-id="element-71">
              Quiero empezar hoy mismo
            </CTAButton>
          </div>

          <span className="mt-4 text-sm font-medium text-ink/60" data-id="element-72">
            Acceso digital inmediato · de por vida
          </span>

          <ul className="mt-7 flex w-full flex-col items-center gap-2 text-left" data-id="element-73">
            {['9 tomos + 5 bonos especiales', 'Más de 100 recetas argentinas', 'Imprimible desde tu casa', 'Lo tenés en menos de 2 minutos'].map(item => <li key={item} className="flex items-center gap-2 text-sm text-ink/70" data-id="element-74">
                <CheckCircle2Icon className="h-4 w-4 shrink-0 text-sage-deep" aria-hidden="true" data-id="element-75" />
                {item}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </header>;
}